// Bepaalt waarderealisatie uit signalen.
// - plan-only scope: niet van toepassing → gray
// - rapport én research aanwezig → green
// - één van beide ontbreekt → yellow
// - geen rapport én geen research → red (onderbenutting bij actief gebruik;
//   explainWaarde() onderscheidt actief vs inactief in de uitleg-tekst)

const computeWaardeRealisatieScore = (entity, signals, productScope) => {
    if (productScope === 'plan-only') return 'gray';

    const hasReport = signals.hasReportLast12mo;
    const hasResearch = signals.researchesLast12mo > 0;

    if (hasReport && hasResearch) return 'green';
    if (hasReport || hasResearch) return 'yellow';

    return 'red';
};

export default computeWaardeRealisatieScore;
